import styled from "styled-components";

const ArticleHeaderStyles = styled.div`
  .article {
    width: 87vw;
    margin: 0 auto;
    position: relative;

    &__banner {
      content: "";
      height: 18px;
      background: var(--light-gray);
      margin-bottom: 80px;

      &--tan {
        background: var(--ts-tan);
      }
    }

    &__eyebrow {
      font-family: var(--header-font);
      font-size: 16px;
      color: var(--medium-gray);
      text-transform: uppercase;
      margin-bottom: 8px;
    }

    &__header {
      font-family: var(--header-font);
      font-size: 48px;
      line-height: 56px;
      max-width: 850px;
      margin-bottom: 10px;
    }

    &__sub-header {
      font-size: 20px;
      line-height: 30px;
      max-width: 800px;
    }

    &__date,
    &__byline {
      text-align: right;
      font-family: var(--header-font);
      font-size: 16px;
      margin-bottom: 7px;
    }

    &__share {
      &-date-divider {
        border-bottom: 2px solid var(--light-gray);
        padding-bottom: 12px;
        padding-top: 60px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
      }

      &-header {
        text-transform: uppercase;
        margin-top: 30px;
        margin-bottom: 10px;
      }

      &-collection {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 10px;
        transform: translateY(-5px);
        /* margin-bottom: 20px; */
      }

      &-item {
        padding-top: 3px;
        margin-right: 12px;

        &--inverted {
          margin-right: 16px;
        }

        div,
        button {
          transition: all 0.2s ease;
          outline: none;

          &:active,
          &:focus {
            outline: none;
            opacity: 1 !important;
          }

          &:hover {
            outline: none;
            opacity: 0.8;
          }
        }

        &--copy {
          /* padding-top: 3px; */
          cursor: pointer;
          /* margin-top: 7px; */

          &:active,
          &:focus {
            outline: none;
            opacity: 1 !important;
          }

          &:hover {
            outline: none;
            opacity: 0.8;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1075px) {
    .article {
      &__banner {
        margin-bottom: 60px;
      }

      &__share {
        &-date-divider {
          // margin-bottom: 40px;
          padding-top: 40px;
        }
      }
    }
  }

  @media only screen and (max-width: 940px) {
    .article {
      width: 75vw;
      margin: 0 auto;

      &__eyebrow {
        font-size: 14px;
        line-height: 22px;
      }

      &__header {
        font-size: 40px;
        line-height: 48px;
      }

      &__sub-header {
        font-size: 18px;
        line-height: 26px;
      }

      &__banner {
        margin-bottom: 60px;
      }
    }
  }

  @media only screen and (max-width: 700px) {
    .article {
      width: 90vw;
      margin: 0 auto;

      &__banner {
        // height: 40px;
        margin-bottom: 40px;
      }

      &__header {
        font-size: 36px;
        line-height: 44px;
      }

      &__date,
      &__byline {
        text-align: left;
      }

      &__share {
        &-collection {
          margin-top: 10px;
        }

        &-date-divider {
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding-top: 20px;

          p {
            margin-top: 8px;
          }
        }
      }
    }
  }
`;

export default ArticleHeaderStyles;
